import { useEffect, useState } from "react";

import { useAppStore } from "../../../../../context/store";
import { Dialog, CloseButton, Button, Input, Text, Select, createListCollection, HStack, useSelectContext, SimpleGrid, Field, VStack, Spinner, Portal, Checkbox } from "@chakra-ui/react";
import { removeEpochSuffix, removeFileExtension, showToast, toCapUnderscore } from "../../../../../utilies/Utility";
import Type from "../../../../../utilies/Types";
import { loadGeojsonTypeAsync } from "../../../../../utilies/loader/LoadGeojson";
import { serviceGetLayerFromPostgreSQL } from "../../../../../api/services/layer";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
import { getEditedGeoJSON } from "../../../../../utilies/geojson/GetEditedGeojson";
import { diffGeoJSON } from "../../../../../utilies/geojson/GetDiffrentGeojson";
import { serviceCreateOrEditProjects } from "../../../../../api/services/project";
import { getProjects } from "../../../../../utilies/services/project/GetProject";
import { saveLayerToServerUnified } from "../../../../../utilies/loader/layer/saveLayerToServer";

const LayersImportFromSQL = () => {
  const db = useAppStore((s) => s.db);
  const showImportFromSQLDialog = useAppStore((s) => s.showImportFromSQLDialog);
  const databases = useAppStore((s) => s.databases);
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);
  const setShowImportFromSQLDialog = useAppStore((s) => s.setShowImportFromSQLDialog);
  const viewerRef = useAppStore((s) => s.viewerRef);
  const originalCameraControls = useAppStore((s) => s.originalCameraControls);
  const loadingDataForLayers = useAppStore((s) => s.loadingDataForLayers);
  const selectedProject = useAppStore((s) => s.selectedProject);
  const userData = useAppStore((s) => s.userData);
  const pointCloudStyle = useAppStore((s) => s.pointCloudStyle);
  const setProjects = useAppStore((s) => s.setProjects);

  const { setMapObjects, mapObjectsRef } = useMapObjects();

  const [isProgress, setIsProgress] = useState(false);

  const [selectedWhere, setSelectedWhere] = useState("");
  const [selectedGeometryField, setSelectedGeometryField] = useState("geom");
  const [selectedDatabaseId, setSelectedDatabaseId] = useState("");
  const [selectedPostgreSQLLayers, setSelectedPostgreSQLLayers] = useState([]);
  const [selectesSchema, setSelectesSchema] = useState([]);
  const [column, setColumn] = useState("");

  const [isAutoSave, setIsAutoSave] = useState(false);

  const [databaseOption, setDatabaseOption] = useState(
    createListCollection({
      items: [],
      itemToString: (item) => item.project.project_name,
      itemToValue: (item) => String(item.id),
    }),
  );
  useEffect(() => {
    if (databases && databases.length > 0) {
      for (const key in databases) {
        if (databases[key].project == null || !databases[key].project) {
          databases[key].project = {
            project_name: toCapUnderscore(databases[key].name),
          };
        }
      }

      const normalizeName = (value) =>
        String(value || "")
          .toLowerCase()
          .replace(/[\s\-_]/g, "");

      const defaultDatabase = databases.find((item) => normalizeName(item?.project?.project_name || item?.name) === normalizeName("Phoenix_Baseline_Road_Phase_Two"));

      if (defaultDatabase) {
        setSelectedDatabaseId(String(defaultDatabase.id));
        setSelectesSchema(defaultDatabase.name);
        setLayersOption(
          createListCollection({
            items: defaultDatabase.tables || [],
            itemToString: (item) => item,
            itemToValue: (item) => item,
          }),
        );
      }

      setDatabaseOption(
        createListCollection({
          items: databases,
          itemToString: (item) => item.project.project_name,
          itemToValue: (item) => String(item.id),
        }),
      );
    }
  }, [databases]);

  const [layersOption, setLayersOption] = useState(
    createListCollection({
      items: [],
      itemToString: (item) => item,
      itemToValue: (item) => item,
    }),
  );

  const SelectValue = () => {
    const select = useSelectContext();

    const items = select.selectedItems;
    if (items.length == 0) return;

    const { name, project } = items[0];
    return (
      <Select.ValueText placeholder="Select Type">
        <HStack>{project?.project_name || name}</HStack>
      </Select.ValueText>
    );
  };

  const yieldToUI = () =>
    new Promise((r) => {
      if (typeof requestIdleCallback === "function") {
        requestIdleCallback(() => r(), { timeout: 100 });
      } else {
        setTimeout(r, 0);
      }
    });

  function createLimiter(concurrency = 1) {
    let active = 0;
    const q = [];
    const runNext = () => {
      if (active >= concurrency || q.length === 0) return;
      active++;
      const { fn, resolve, reject } = q.shift();
      fn()
        .then(resolve, reject)
        .finally(() => {
          active--;
          runNext();
        });
    };
    return (fn) =>
      new Promise((resolve, reject) => {
        q.push({ fn, resolve, reject });
        runNext();
      });
  }

  const saveAllLayers = async (item, mapObjects) => {
    const projectId = item.id;

    let listOfLayersId = [];
    let tempMapObjects = [...mapObjects];
    for (const key in mapObjects) {
      if (mapObjects[key]?.layer_id) {
        listOfLayersId.push(mapObjects[key]?.layer_id);
      }
    }
    for (const key in mapObjects) {
      setIsProgress(true);

      await saveLayerToServerUnified({
        layer: mapObjects[key],
        userData,
        pointCloudStyle,
        description: "",
        createFileBaseName: removeEpochSuffix(removeFileExtension(mapObjects[key].file_name)),
        attachFile: "always",
        sendLayerId: false,
      })
        .then((res) => {
          if (res.data.status == "failed") {
            showToast(res.data.message, Type.NOTIFICATION.WARNING);
          } else {
            showToast("Stored " + removeEpochSuffix(removeFileExtension(res.data.layer_name)), Type.NOTIFICATION.SUCCESS);
            listOfLayersId.push(res.data.layer_id);
            tempMapObjects[key].file_name = removeFileExtension(res.data.layer_name) + mapObjects[key].file_type;
            tempMapObjects[key].is_edited = false;
            tempMapObjects[key].project_id = projectId;
            tempMapObjects[key].layer_id = res.data.layer_id;
            tempMapObjects[key].original_geojson = getEditedGeoJSON(mapObjects[key]);
          }
        })
        .catch((err) => {
          console.error("Error", err);
          setIsProgress(false);
        });
    }

    setMapObjects(() => tempMapObjects);

    const formData = new FormData();
    formData.append(
      "data",
      JSON.stringify({
        username: userData.user.username,
        layers: [...new Set(listOfLayersId)],
      }),
    );
    formData.append("project_id", projectId);

    serviceCreateOrEditProjects(formData, userData.token)
      .then((res) => {
        if (res.data.status == "success") {
          showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
          getProjects({
            userData,
            setProjects,
            onSuccess: () => {
              setIsProgress(false);
            },
            onError: () => {
              setIsProgress(false);
            },
          });
        }
      })
      .catch((err) => {
        showToast(err.message, Type.NOTIFICATION.WARNING);
        console.error("Error", err);
      });
  };

  const importFromPostgreSQL = () => {
    for (const key in selectedPostgreSQLLayers) {
      const formData = new FormData();
      formData.append(
        "params",
        JSON.stringify({
          table_name: selectedPostgreSQLLayers[key],
          schema: selectesSchema,
          database: db,
          limit: 1000,
          offset: 0,
          geometry_field: selectedGeometryField,
          where: selectedWhere,
        }),
      );

      setIsProgress(true);
      serviceGetLayerFromPostgreSQL(formData)
        .then(async (res) => {
          if (res.data?.status && res.data.status === "failed") {
            showToast(res.data.message, Type.NOTIFICATION.WARNING);
          } else {
            setShowImportFromSQLDialog(false);

            let working = mapObjectsRef.current;
            const setMapObjectsProxy = (updater) => {
              working = typeof updater === "function" ? updater(working) : updater;
              setMapObjects(updater);
            };

            let geojson = res.data;

            if (geojson) {
              if (geojson.features == null) geojson.features = [];
              if (column && column.trim() !== "") {
                const colKey = column.trim();
                const features = Array.isArray(geojson.features) ? geojson.features : [];

                const limit = createLimiter(1);
                const YIELD_EVERY = 10;

                let i = 0;
                loadingDataForLayers.current = {
                  current: 0,
                  total: features.length,
                  message: "",
                  show: true,
                };
                for (; i < features.length; i++) {
                  const f = features[i];
                  const props = f?.properties || {};
                  if (!(colKey in props)) continue;

                  let rawName = props[colKey];
                  let baseName = rawName === null || rawName === undefined || String(rawName).trim() === "" ? `unnamed_${i + 1}` : String(rawName).trim();

                  baseName = baseName.replace(/\s+/g, " ");

                  const singleGeojson = {
                    ...geojson,
                    type: "FeatureCollection",
                    features: [f],
                  };

                  await limit(() =>
                    loadGeojsonTypeAsync({
                      originalCameraControls,
                      geojsonData: singleGeojson,
                      fileName: baseName,
                      viewerRef,
                      setMapObjects: setMapObjectsProxy,
                      defaultGeojsonStyle,
                      basicGeojsonStyle,
                      defaultOsmStyle,
                      isLoadFromDatabase: false,
                      sqlSchema: selectesSchema,
                      sqlWhere: selectedWhere,
                      sqlTable: selectedPostgreSQLLayers[key],
                      sqlGeometryField: selectedGeometryField,
                      sqlDB: db,
                      loadingDataForLayers,
                      selectedProject,
                      isAutoSave: isAutoSave,
                      isEdited: true,
                    }),
                  );

                  if (i % YIELD_EVERY === 0) await yieldToUI();
                }
              } else {
                await loadGeojsonTypeAsync({
                  originalCameraControls,
                  geojsonData: geojson,
                  fileName: selectedPostgreSQLLayers[key],
                  viewerRef,
                  setMapObjects: setMapObjectsProxy,
                  defaultGeojsonStyle,
                  basicGeojsonStyle,
                  defaultOsmStyle,
                  isLoadFromDatabase: true,
                  sqlSchema: selectesSchema,
                  sqlWhere: selectedWhere,
                  sqlTable: selectedPostgreSQLLayers[key],
                  sqlGeometryField: selectedGeometryField,
                  sqlDB: db,
                  isAutoSave: true,
                  selectedProject,
                  isAutoSave: isAutoSave,
                  isEdited: true,
                });
              }
              if (isAutoSave && selectedProject) {
                await saveAllLayers(selectedProject, working);
              }
            } else {
              showToast("There is no value for the layer " + selectedPostgreSQLLayers[key], Type.NOTIFICATION.WARNING);
            }
          }
        })
        .catch((err) => {
          console.error("Error", err);
        })
        .finally(() => {
          setIsProgress(false);
        });
    }
  };

  return (
    <Dialog.Root modal={false} open={showImportFromSQLDialog} closeOnInteractOutside={false}>
      <Portal>
        <Dialog.Positioner style={{ pointerEvents: "none" }}>
          <Dialog.Content style={{ pointerEvents: "auto" }}>
            <Dialog.Header>
              <VStack>
                <Dialog.Title width={"full"}>Import From PostgreSQL</Dialog.Title>
                <Text width={"full"}>Databse: {db}</Text>
              </VStack>
            </Dialog.Header>

            <Dialog.Body>
              <Select.Root
                collection={databaseOption}
                size="sm"
                width="full"
                positioning={{ sameWidth: true }}
                value={selectedDatabaseId ? [selectedDatabaseId] : []}
                onValueChange={(value) => {
                  const selectedId = Array.isArray(value.value) ? value.value[0] : value.value;
                  setSelectedDatabaseId(String(selectedId || ""));

                  for (const key in databases) {
                    if (String(databases[key].id) === String(selectedId)) {
                      setSelectesSchema(databases[key].name);

                      setLayersOption(
                        createListCollection({
                          items: databases[key].tables,
                          itemToString: (item) => item,
                          itemToValue: (item) => item,
                        }),
                      );
                      break;
                    }
                  }
                }}
              >
                <Select.HiddenSelect />
                <Select.Label mt={2}>Select Project</Select.Label>
                <Select.Control>
                  <Select.Trigger>
                    <SelectValue />
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>
                <Select.Positioner>
                  <Select.Content>
                    {databaseOption.items.map((item) => (
                      <Select.Item item={item} key={item.id} justifyContent="flex-start">
                        {item?.project?.project_name}
                        <Select.ItemIndicator />
                      </Select.Item>
                    ))}
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>
              <Select.Root
                collection={layersOption}
                size="sm"
                width="full"
                positioning={{ sameWidth: true }}
                multiple
                onValueChange={(value) => {
                  setSelectedPostgreSQLLayers(value.value);
                }}
              >
                <Select.HiddenSelect />
                <Select.Label mt={2}>Select Layers</Select.Label>
                <Select.Control>
                  <Select.Trigger>
                    {selectedPostgreSQLLayers.length > 0 ? (
                      <div className="flex flex-wrap gap-1">
                        {selectedPostgreSQLLayers.map((layer) => (
                          <span key={layer} className="px-2 py-1 bg-gray-200 rounded-md text-sm">
                            {layer} ,
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span className="text-gray-400">Select Layers</span>
                    )}
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>
                <Select.Positioner>
                  <Select.Content>
                    <SimpleGrid columns={2} spacing={2} p={2}>
                      {layersOption.items.map((item) => (
                        <Select.Item item={item} key={item} justifyContent="flex-start">
                          {item}
                          <Select.ItemIndicator />
                        </Select.Item>
                      ))}
                    </SimpleGrid>
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>
              <Field.Root mt={3}>
                <Field.Label>Geometry Field</Field.Label>
                <Input list="geometry-fields" placeholder="Enter ..." value={selectedGeometryField} onChange={(v) => setSelectedGeometryField(v.target.value)} />
                <datalist id="geometry-fields">
                  <option value="geom" />
                  <option value="the_geom" />
                  <option value="simplified_geom" />
                  <option value="geometry" />
                  <option value="point" />
                  <option value="center" />
                  <option value="waypoints" />
                  <option value="location" />
                  <option value="trace" />
                  <option value="positon" />
                  <option value="polygon" />
                  <option value="line" />
                </datalist>
              </Field.Root>
              <Field.Root mt={3}>
                <Field.Label>Where</Field.Label>
                <Input placeholder="Enter ..." value={selectedWhere} onChange={(v) => setSelectedWhere(v.target.value)} />
              </Field.Root>

              <Field.Root mt={3}>
                <Field.Label>Column</Field.Label>
                <Input placeholder="Enter ..." value={column} onChange={(v) => setColumn(v.target.value)} />
              </Field.Root>

              <Checkbox.Root checked={isAutoSave} mt={3} display="flex" alignItems="center" gap={2} onCheckedChange={(e) => setIsAutoSave(!!e.checked)}>
                <Checkbox.HiddenInput />
                <Checkbox.Control />
                <Checkbox.Label m={0} lineHeight="1">
                  Auto Save
                </Checkbox.Label>
              </Checkbox.Root>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowImportFromSQLDialog(false);
                  }}
                >
                  Cancel
                </Button>
              </Dialog.ActionTrigger>

              <Button onClick={importFromPostgreSQL}>{isProgress ? <Spinner /> : "Load"}</Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger
              asChild
              onClick={() => {
                setShowImportFromSQLDialog(false);
              }}
            >
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersImportFromSQL;
